import React from "react"
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { logout } from 'data/auth/action'
import hourglass from 'img/hourglass.png'
import './style.css'

class TimeoutPage extends React.Component{
  constructor(props) {
    super(props)
    props.logout()
  }

  render(){
    return(
      <div className="TimeoutScreen">
        <div className="TimeoutMessage">
          <img id='hourglass' src={hourglass} alt='Hourglass' />
          <div>Your Session has expired.</div>
          <div>Please login again to continue.</div>
          <div><Link className='loginLink' to='/login' tabIndex={-1}>Return to Login</Link></div>
        </div>
      </div>
    )
  }
}

export default connect(null, { logout } )(TimeoutPage)
